export default __webpack_public_path__ + "static/media/strech-yarn.234eec19.svg";